import { useState, type FormEvent } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { CognitoService } from '@/auth/CognitoService';
import { useAuth } from '@/auth/useAuth';
import { Button, Screen, TextField } from '../../ui';

export default function Confirm() {
  const { confirmSignUp } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const emailFromSignUp = (location.state as { email?: string } | null)?.email ?? '';

  const [email, setEmail] = useState(emailFromSignUp);
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [notice, setNotice] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await confirmSignUp(email.trim(), code.trim());
      navigate('/sign-in', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'That code was not accepted.');
    } finally {
      setBusy(false);
    }
  }

  async function resend(): Promise<void> {
    setError(null);
    setNotice(null);
    try {
      await CognitoService.resendConfirmation(email.trim());
      setNotice('We sent another code.');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not send another code.');
    }
  }

  return (
    <Screen title="Check your email">
      <p className="type-body">Enter the code we sent you.</p>
      <form onSubmit={submit} noValidate>
        {!emailFromSignUp && <TextField label="Email" type="email" value={email} onChangeText={setEmail} />}
        <TextField label="Code" value={code} onChangeText={setCode} placeholder="123456" />
        {error && <p role="alert" className="type-caption field-error-text">{error}</p>}
        {notice && <p role="status" className="type-caption">{notice}</p>}
        <Button title="Confirm" type="submit" loading={busy} />
      </form>
      <Button title="Resend code" variant="ghost" onPress={resend} />
    </Screen>
  );
}
